export const EXAMPLE_PATH = 'cms-t&l'
export const CMS_NAME = 'T&L'
export const CMS_URL = 'https://google.com'
export const HOME_OG_IMAGE_URL =
  'https://og-image.now.sh/Next.js%20Blog%20Example%20with%20**WordPress**.png?theme=light&md=1&fontSize=75px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fnextjs-black-logo.svg&images=data%3Aimage%2Fsvg%2Bxml%2C%253C%253Fxml+version%3D%271.0%27+encoding%3D%27UTF-8%27%253F%253E%253Csvg+preserveAspectRatio%3D%27xMidYMid%27+version%3D%271.1%27+viewBox%3D%270+0+256+255%27+xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%253E%253Cg+fill%3D%27%2523464342%27%253E%253Cpath+d%3D%27m18.124+127.5c0+43.295+25.161+80.711+61.646+98.441l-52.176-142.96c-6.0691+13.603-9.4699+28.657-9.4699+44.515zm183.22-5.5196c0-13.518-4.8557-22.88-9.0204-30.166-5.5446-9.01-10.742-16.64-10.742-25.65+0-10.055+7.6259-19.414+18.367-19.414+0.48494+0+0.94491+0.060358+1.4174+0.087415-19.46-17.828-45.387-28.714-73.863-28.714-38.213+0-71.832+19.606-91.39+49.302+2.5662+0.077008+4.9847+0.13112+7.039+0.13112+11.441+0+29.151-1.3882+29.151-1.3882+5.8963-0.34758+6.5915+8.3127+0.7014+9.01+0+0-5.9255+0.69724-12.519+1.0427l39.832+118.48+23.937-71.79-17.042-46.692c-5.8901-0.3455-11.47-1.0427-11.47-1.0427-5.8942-0.3455-5.2033-9.3575+0.69099-9.01+0+0+18.064+1.3882+28.811+1.3882+11.439+0+29.151-1.3882+29.151-1.3882+5.9005-0.34758+6.5936+8.3127+0.7014+9.01+0+0-5.938+0.69724-12.519+1.0427l39.528+117.58+10.91-36.458c4.7287-15.129+8.3273-25.995+8.3273-35.359zm-71.921+15.087l-32.818+95.363c9.7988+2.8805+20.162+4.4561+30.899+4.4561+12.738+0+24.953-2.202+36.323-6.2002-0.29346-0.46829-0.55987-0.96572-0.77841-1.5069l-33.625-92.112zm94.058-62.046c0.47037+3.4841+0.73678+7.2242+0.73678+11.247+0+11.1-2.073+23.577-8.3169+39.178l-33.411+96.599c32.518-18.963+54.391-54.193+54.391-94.545+0.002081-19.017-4.8557-36.899-13.399-52.48zm-95.977-75.023c-70.304+0-127.5+57.196-127.5+127.5+0+70.313+57.2+127.51+127.5+127.51+70.302+0+127.51-57.194+127.51-127.51-0.002082-70.304-57.209-127.5-127.51-127.5zm0+249.16c-67.08+0-121.66-54.578-121.66-121.66+0-67.08+54.576-121.65+121.66-121.65+67.078+0+121.65+54.574+121.65+121.65+0+67.084-54.574+121.66-121.65+121.66z%27%2F%253E%253C%2Fg%253E%253C%2Fsvg%253E'

export const IS_PARALLAX = 2
export const NOT_PARALLAX = 1
export const FRONT_END_HOST = FEH
export const S3_URL = S3U
export const HTML_REGEX = /<\/?[a-z][\s\S]*>/
export const APIS = {
  newpage_add: '/api/v1/newpage/save',
  newpage_edit: '/api/v1/newpage/edit',
  get_images: '/api/v1/images',
  image_upload: '/api/v1/images/multi_upload',
  get_home_structure: '/api/v1/page_structure_tree',
  get_setting_header: '/api/v1/setting_header',
  get_setting_footer: '/api/v1/setting_footer',
  get_general_seting: '/api/v1/general_settings',
  get_common_footer_navigation: '/api/v1/common_footer_navigation',
  get_data: '/api/v1/newpage/get/data',
  get_all_page: '/api/v1/newpages',
  get_detail_setting: '/api/v1/newpages/detail/settings',
  get_favorite_categories: '/api/v1/favorites/categories',
  create_favorite: '/api/v1/favorites',
  favorites_path: '/api/v1/favorites',
  responsive: '/api/v1/responsives',
  footer_save: '/api/v1/newpage/footer/save',
  get_favorite: '/api/v1/newpages/favorite',
  page_get_data: '/api/v1/pages/get/data',
  page_detail_setting: '/api/v1/pages/detail/settings',
  common_navigation: '/api/v1/common/navigations',
  common_navigation_page: '/api/v1/common/navigation/pages',
  web_content: '/api/v1/scraper/scrape',
  get_newpage_categories: '/api/v1/newpage_categories/list',
  get_blogs: '/api/v1/newpage/blogs',
  get_news: '/api/v1/newpage/news',
  get_comparison_categories: '/api/v1/comparison_categories',
  get_comparisons: '/api/v1/comparisons',
  get_questions: '/api/v1/questions/list',
  get_shops: '/api/v1/shops/list',
  get_menus: '/api/v1/menus',
  get_galleries: '/api/v1/galleries',
  get_gallery_categories: '/api/v1/gallery_categories',
  get_access_token: '/api/v1/access_token',
  get_account_access_token: '/api/v1/account_access_token',
  get_contacts_options: '/api/v1/contacts/options',
  get_contact_details: '/api/v1/contacts/detail',
  get_change_logs: '/api/v1/change_log/list',
  navigation_header_setting: '/api/v1/navigations/header/setting',
  navigation_footer_setting: '/api/v1/navigations/footer/setting',
  navigation_menu: '/api/v1/navigations/menu',
  get_coupons: '/api/v1/coupons',
  get_staff_categories: '/api/v1/staff_categories',
  get_staffs: '/api/v1/staffs',
  get_templates: '/api/v1/templates',
  get_categories_recruits: '/api/v1/categories/recruit',
  get_recruits: '/api/v1/recruits',
  get_tags: '/api/v1/tags',
  get_same_category: '/api/v1/newpages/same_category',
  get_blog_setting: '/api/v1/blog_setting',
  get_news_setting: '/api/v1/news_setting',
  get_setting_advanced: '/api/v1/settings/advanced',
  get_tenants: '/api/v1/tenants',
  copy_template: '/api/v1/template/copy',
}

export const IMAGES = {
  logo_sample: require('../assets/images/logo_sample.png'),
  no_image: require('../assets/images/no_image.jpg'),
  text_type_1: require('../assets/images/text_type_1.jpg'),
  text_type_2: require('../assets/images/text_type_2.jpg'),
  text_type_3: require('../assets/images/text_type_3.jpg'),
  text_type_4: require('../assets/images/text_type_4.jpg'),
  block_image_1: require('../assets/images/block_image_1.jpg'),
  block_image_2: require('../assets/images/block_image_2.jpg'),
  image_text_1: require('../assets/images/image_text/1.jpg'),
  image_text_2: require('../assets/images/image_text/2.jpg'),
  image_text_3: require('../assets/images/image_text/3.jpg'),
  image_text_4: require('../assets/images/image_text/4.jpg'),
  image_text_5: require('../assets/images/image_text/5.jpg'),
  image_text_6: require('../assets/images/image_text/6.jpg'),
  image_text_7: require('../assets/images/image_text/7.jpg'),
  image_text_8: require('../assets/images/image_text/8.jpg'),
  image_text_9: require('../assets/images/image_text/9.jpg'),
  image_text_10: require('../assets/images/image_text/10.jpg'),
  image_text_11: require('../assets/images/image_text/11.jpg'),
  image_text_12: require('../assets/images/image_text/12.jpg'),
  image_text2_1: require('../assets/images/image_text2/1.jpg'),
  image_text2_2: require('../assets/images/image_text2/2.jpg'),
  image_text2_3: require('../assets/images/image_text2/3.jpg'),
  image_text2_4: require('../assets/images/image_text2/4.jpg'),
  image_text2_5: require('../assets/images/image_text2/5.jpg'),
  image_text2_6: require('../assets/images/image_text2/6.jpg'),
  image_text2_7: require('../assets/images/image_text2/7.jpg'),
  image_text2_8: require('../assets/images/image_text2/8.jpg'),
  image_text2_9: require('../assets/images/image_text2/9.jpg'),
  image_text2_10: require('../assets/images/image_text2/10.jpg'),
  image_text2_11: require('../assets/images/image_text2/11.jpg'),
  image_text2_12: require('../assets/images/image_text2/12.jpg'),
  image_text2_13: require('../assets/images/image_text2/13.jpg'),
  image_text2_14: require('../assets/images/image_text2/14.jpg'),
  image_text2_15: require('../assets/images/image_text2/15.jpg'),
  image_text2_16: require('../assets/images/image_text2/16.jpg'),
  image_text2_17: require('../assets/images/image_text2/17.jpg'),
  heading_1: require('../assets/images/heading/heading_1.png'),
  heading_2: require('../assets/images/heading/heading_2.png'),
  heading_3: require('../assets/images/heading/heading_3.png'),
  heading_4: require('../assets/images/heading/heading_4.png'),
  heading_5: require('../assets/images/heading/heading_5.png'),
  heading_6: require('../assets/images/heading/heading_6.png'),
  heading_7: require('../assets/images/heading/heading_7.png'),
  heading_with_sub_1: require('../assets/images/heading_with_sub/heading_with_sub_1.png'),
  heading_with_sub_2: require('../assets/images/heading_with_sub/heading_with_sub_2.png'),
  heading_with_sub_3: require('../assets/images/heading_with_sub/heading_with_sub_3.png'),
  heading_with_sub_4: require('../assets/images/heading_with_sub/heading_with_sub_4.png'),
  heading_with_sub_5: require('../assets/images/heading_with_sub/heading_with_sub_5.png'),
  heading_with_sub_6: require('../assets/images/heading_with_sub/heading_with_sub_6.png'),
  heading_with_sub_7: require('../assets/images/heading_with_sub/heading_with_sub_7.png'),
  line_1: require('../assets/images/line_1.jpg'),
  line_2: require('../assets/images/line_2.jpg'),
  line_3: require('../assets/images/line_3.jpg'),
  line_4: require('../assets/images/line_4.jpg'),
  line_5: require('../assets/images/line_5.jpg'),
  map: require('../assets/images/embedded_parts/map.jpg'),
  youtube: require('../assets/images/embedded_parts/youtube.jpg'),
  block_table_1: require('../assets/images/tables/block_table_1.jpg'),
  block_table_2: require('../assets/images/tables/block_table_2.jpg'),
  block_table_3: require('../assets/images/tables/block_table_3.jpg'),
  block_table_5: require('../assets/images/tables/block_table_5.jpg'),
  block_table_6: require('../assets/images/tables/block_table_6.jpg'),
  block_table_7: require('../assets/images/tables/block_table_7.jpg'),
  block_table_8: require('../assets/images/tables/block_table_8.jpg'),
  block_link_1: require('../assets/images/block_link_1.jpg'),
  blog_1: require('../assets/images/blogs/1'),
  blog_2: require('../assets/images/blogs/2'),
  blog_3: require('../assets/images/blogs/3'),
  blog_4: require('../assets/images/blogs/4'),
  blog_5: require('../assets/images/blogs/5'),
  blog_6: require('../assets/images/blogs/6'),
  blog_7: require('../assets/images/blogs/7'),
  blog_8: require('../assets/images/blogs/8'),
  blog_9: require('../assets/images/blogs/9'),
  blog_10: require('../assets/images/blogs/10'),
  blog_11: require('../assets/images/blogs/11'),
  blog_12: require('../assets/images/blogs/12'),
  blog_13: require('../assets/images/blogs/13'),
  tel1: require('../assets/images/embedded_parts/tel1.png'),
  tel2: require('../assets/images/embedded_parts/tel2.jpg'),
  company1: require('../assets/images/embedded_parts/company1.jpg'),
  company2: require('../assets/images/embedded_parts/company2.jpg'),
  conversation1: require('../assets/images/embedded_parts/conversation1.jpg'),
  conversation2: require('../assets/images/embedded_parts/conversation2.jpg'),
  before_after_1: require('../assets/images/before_and_after/before_after_1.jpg'),
  before_after_2: require('../assets/images/before_and_after/before_after_2.jpg'),
  before_after_3: require('../assets/images/before_and_after/before_after_3.jpg'),
  before_after_4: require('../assets/images/before_and_after/before_after_4.jpg'),
  question_1: require('../assets/images/question_1.jpg'),
  menu_1: require('../assets/images/menu_1.jpg'),
  menu_2: require('../assets/images/menu_2.jpg'),
  menu_3: require('../assets/images/menu_3.jpg'),
  menu_4: require('../assets/images/menu_4.jpg'),
  menu_5: require('../assets/images/menu_5.jpg'),
  menu_6: require('../assets/images/menu_6.jpg'),
  gallery_1: require('../assets/images/gallery_1.jpg'),
  gallery_2: require('../assets/images/gallery_2.jpg'),
  gallery_3: require('../assets/images/gallery_3.jpg'),
  gallery_4: require('../assets/images/gallery_4.jpg'),
  gallery_5: require('../assets/images/gallery_5.jpg'),
  button_2: require('../assets/images/button/button_2.jpg'),
  form_1: require('../assets/images/form_1.jpg'),
  news_1: require('../assets/images/news/news_1.jpg'),
  news_2: require('../assets/images/news/news_2.jpg'),
  news_3: require('../assets/images/news/news_3.jpg'),
  news_4: require('../assets/images/news/news_4.jpg'),
  news_5: require('../assets/images/news/news_5.jpg'),
  news_6: require('../assets/images/news/news_6.jpg'),
  news_7: require('../assets/images/news/news_7.jpg'),
  news_8: require('../assets/images/news/news_8.jpg'),
  news_9: require('../assets/images/news/news_9.jpg'),
  news_10: require('../assets/images/news/news_10.jpg'),
  news_11: require('../assets/images/news/news_11.jpg'),
  news_12: require('../assets/images/news/news_12.jpg'),
  news_13: require('../assets/images/news/news_13.jpg'),
  coupon_1: require('../assets/images/coupon/coupon_1.jpg'),
  staff_1: require('../assets/images/staffs/staff_1.jpg'),
  staff_2: require('../assets/images/staffs/staff_2.jpg'),
  recruit_1: require('../assets/images/recruits/block_recruit_1.jpg'),
  recruit_2: require('../assets/images/recruits/block_recruit_2.jpg'),
  twitter_icon: require('../assets/images/twitter.svg'),
}
